import { render, staticRenderFns } from "./Internal-Property-Address-To-customer.vue?vue&type=template&id=6c98a8f3"
import script from "./Internal-Property-Address-To-customer.vue?vue&type=script&lang=js"
export * from "./Internal-Property-Address-To-customer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports